import React, { useContext, useState } from 'react';
import { Dialog, DialogContent, IconButton, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

import { getS3URL } from '../../../api/update_guidance';
import { getLabelComparison } from '../../../api/AdminPage';

import Store from '../../../store';
import Actions from '../../../store/actions';

const ComparePdfs = ({ fdaURL, riaPath }: { fdaURL: string; riaPath: string }) => {
  const { dispatch } = useContext<any>(Store);

  const [comparePdfUrl, setComparePdfUrl] = useState('');
  const [compareOpen, setCompareOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const getComparisonUrl = async (parentUrl: string, childUrl: string) => {
    const response = await getLabelComparison({
      parent_object: parentUrl,
      child_object: childUrl
    });

    if (response.data && response.data.success) {
      setComparePdfUrl(response.data.success);
      setCompareOpen(true);
    } else {
      throw new Error(response.data.Error);
    }
  };

  const getRIAS3Url = async () => {
    try {
      setLoading(true);
      const riaS3Request = getS3URL({ path: riaPath });
      const fdaS3Request = getS3URL({ path: fdaURL });

      const riaS3Response = await riaS3Request;
      const fdaS3Response = await fdaS3Request;

      await getComparisonUrl(riaS3Response.data.Success.s3_url, fdaS3Response.data.Success.s3_url);
    } catch (error) {
      console.error(error);
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: `Failed to get the compare pdf url. ${error}` }
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingButton
        loading={loading}
        variant='contained'
        onClick={() => {
          setCompareOpen(true);
          getRIAS3Url();
        }}
        sx={{ maxWidth: 100 }}>
        Compare
      </LoadingButton>
      {comparePdfUrl && compareOpen && (
        <Dialog open={compareOpen} onClose={() => setCompareOpen(false)} maxWidth='xl'>
          <DialogContent>
            <IconButton
              sx={{ position: 'absolute', top: 8, right: 16 }}
              onClick={() => setCompareOpen(false)}>
              <Close />
            </IconButton>
            <Stack direction='row' justifyContent='space-around'>
              <Typography component='h3' fontWeight={600}>
                RIA PDF
              </Typography>
              <Typography component='h3' fontWeight={600}>
                FDA PDF
              </Typography>
            </Stack>
            <iframe
              style={{ height: '75vh', width: '80vw' }}
              src={comparePdfUrl}
              title='Re added comprison'
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default React.memo(ComparePdfs);
